import { ChildModel, ModelBase } from 'store/model-base';
import { Account } from './account';
import { AllowedLines } from './allowed-lines';
import { UserState } from 'my-account/constants';
import { StreetAddress } from 'store/user/models/address/street';

export class User extends ModelBase {
    public static storeName: string = 'user';

    public account: Account;
    public allowedLines: AllowedLines;

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'account',
            model: Account
        }, {
            attrName: 'allowedLines',
            model: AllowedLines
        }];
    }

    public get businessAccountNumber(): string {
        return this.account.id.value;
    }

    public get businessName(): string {
        return this.account.displayName;
    }

    public get authorizedBusinessRepName(): string {
        return `${this.account.authorizedBusinessRepresentativeContact?.firstName} ${this.account.authorizedBusinessRepresentativeContact?.lastName}` || '';
    }

    public get accountNo(): string {
        return (this.account.id ? this.account.id.value : '') || '';
    }

    public get displayName(): string {
        return this.account.displayName;
    }

    public get loggedInUserName(): string {
        return this.account.loggedInUserName;
    }

    public get displayFirstName(): string {
        return this.account.firstName || '';
    }

    public get serviceAddress(): StreetAddress {
        return this.account.serviceAddress;
    }

    public get notificationPhone(): string {
        return this.account.notificationContacts ? this.account.notificationContacts.sms : '';
    }

    public get notificationEmail(): string {
        return this.account.notificationContacts ? this.account.notificationContacts.email : '';
    }

    public get nextCycleDate(): Date {
        return this.account ? this.account.nextCycleDate : new Date();
    }

    public get isXfinityMobileCustomer(): boolean {
        return this.account.state === UserState.ACTIVE;
    }

    public get authGuid(): string {
        return this.account.authGuid;
    }
}
